import { useState,useRef,useEffect } from 'react'
import useCurrentTeacher from '../../../../hooks/useCurrentTeacher'

const VideoIntro = () => {
  const { teacher, fetchCurrentTeacher } = useCurrentTeacher()
  const [selectedFiles, setSelectedFiles] = useState([])
  const [editingIndex, setEditingIndex] = useState(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null) 
    const dropdownRef = useRef(null)
     useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownIndex(null)
      }
    }
  
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [dropdownRef])
  if (!teacher) return null

  const handleAdd = async () => {
    if (selectedFiles.length === 0) {
      setError('Please select at least one video.')
      return
    }
    setLoading(true)
    try {
      const formData = new FormData()
      formData.append('video', selectedFiles[0])

      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/teacher/${teacher.id}/videos/add/`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        body: formData,
      })

      if (res.ok) {
        alert('Video added successfully!')
        fetchCurrentTeacher()
        setSelectedFiles([])
        setError('')
      } else {
        const data = await res.json()
        alert(data.msg || 'Failed to add video')
      }
    } catch (err) {
      console.error(err)
      alert('Error adding video')
    } finally {
      setLoading(false)
    }
  }

  const handleEdit = async (index) => {
    if (!selectedFiles[index]) {
      setError('Please select a video to update.')
      return
    }

    const videoId = teacher.videos[index].id
    setLoading(true)
    try {
      const formData = new FormData()
      formData.append('video', selectedFiles[index])

      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/teacher/videos/${videoId}/edit/`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        body: formData,
      })

      if (res.ok) {
        alert('Video updated successfully!')
        fetchCurrentTeacher()
        setSelectedFiles([])
        setEditingIndex(null)
        setError('')
      } else {
        const data = await res.json()
        alert(data.msg || 'Failed to update video')
      }
    } catch (err) {
      console.error(err)
      alert('Error updating video')
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = async (index) => {
    if (!window.confirm('Are you sure you want to delete this video?')) return

    const videoId = teacher.videos[index].id
    setLoading(true)
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/teacher/videos/${videoId}/delete/`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      })

      if (res.ok) {
        alert('Video deleted successfully!')
        fetchCurrentTeacher()
      } else {
        const data = await res.json()
        alert(data.msg || 'Failed to delete video')
      }
    } catch (err) {
      console.error(err)
      alert('Error deleting video')
    } finally {
      setLoading(false)
    }
  }

  return (
 <div className="p-2 md:p-6 w-full max-w-6xl mx-auto bg-white rounded-2xl border border-gray-200 shadow-sm">
  {/* Header */}
  <div className="flex items-center justify-between mb-6 pb-4 border-b border-gray-100">
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
        <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
        </svg>
      </div>
      <div>
        <h2 className="text-xl font-semibold text-gray-900">Your Videos</h2>
        <p className="text-sm text-gray-500 mt-0.5">Manage your video content</p>
      </div>
    </div>

    <div className="flex items-center gap-3">
      <label
        title="Add New Video"
        className="w-10 h-10 bg-[#0f6abf] rounded-xl flex items-center justify-center cursor-pointer hover:bg-[#0a5ca8] transition-colors shadow-sm"
      >
        <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
        </svg>
        <input
          type="file"
          accept="video/*"
          className="hidden"
          onChange={(e) => {
            setSelectedFiles([e.target.files[0]])
            setEditingIndex(null)
          }}
        />
      </label>

      {selectedFiles.length > 0 && editingIndex === null && (
        <button
          onClick={handleAdd}
          disabled={loading}
          className="px-5 py-2.5 bg-green-600 text-white text-sm font-medium rounded-xl hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
          </svg>
          {loading ? 'Uploading...' : 'Upload'}
        </button>
      )}
    </div>
  </div>

  {/* Error */}
  {error && (
    <div className="flex items-center gap-2 p-4 mb-6 bg-red-50 border border-red-200 rounded-xl text-red-600">
      <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <p className="text-sm">{error}</p>
    </div>
  )}

  {/* New Video Preview */}
  {selectedFiles.length > 0 && editingIndex === null && (
    <div className="mb-6 p-5 bg-gray-50 rounded-xl border-2 border-dashed border-[#0f6abf]">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <h4 className="text-sm font-semibold text-gray-900">New Video Preview</h4>
      </div>
      <p className="text-sm text-gray-600 mb-3">
        Selected: <span className="font-medium">{selectedFiles[0].name}</span>
      </p>
      <video
        src={URL.createObjectURL(selectedFiles[0])}
        controls
        className="w-full max-h-[300px] rounded-xl shadow-sm"
      />
    </div>
  )}

  {/* Videos List */}
  {teacher.videos?.length > 0 ? (
    <div className="space-y-6">
      {teacher.videos.map((videoObj, index) => (
        <div
          key={videoObj.id}
          className="relative bg-white rounded-xl border border-gray-200 p-5 shadow-sm hover:border-gray-300 transition-colors"
        >
          <video
            src={videoObj.file}
            controls
            className="w-full rounded-xl max-h-[500px]"
          />

          {/* Edit Mode */}
          {editingIndex === index && selectedFiles[index] ? (
            <div className="absolute top-3 right-3 flex gap-2 z-10">
              <button
                onClick={() => handleEdit(index)}
                disabled={loading}
                className="px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50 flex items-center gap-2"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                {loading ? 'Saving...' : 'Save Changes'}
              </button>

              <button
                disabled={loading}
                onClick={() => {
                  const newFiles = [...selectedFiles]
                  newFiles[index] = null
                  setSelectedFiles(newFiles)
                  setEditingIndex(null)
                }}
                className="px-4 py-2 bg-gray-200 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-300 transition-colors disabled:opacity-50"
              >
                Cancel
              </button>
            </div>
          ) : (
            /* Dropdown Mode */
            <div className="absolute top-3 right-3">
              <button
                onClick={() =>
                  setOpenDropdownIndex(
                    openDropdownIndex === index ? null : index
                  )
                }
                className="w-8 h-8 bg-white rounded-lg flex items-center justify-center hover:bg-gray-100 transition-colors shadow-sm"
              >
                <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                </svg>
              </button>

              {openDropdownIndex === index && (
                <div
                  ref={dropdownRef}
                  className="absolute right-0 top-10 mt-1 bg-white rounded-xl shadow-lg border border-gray-200 py-1 w-36 z-10"
                >
                  <label className="flex items-center gap-2 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer transition-colors">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                    Edit
                    <input
                      type="file"
                      accept="video/*"
                      className="hidden"
                      onChange={(e) => {
                        setSelectedFiles((prev) => {
                          const newFiles = [...prev]
                          newFiles[index] = e.target.files[0]
                          return newFiles
                        })
                        setEditingIndex(index)
                      }}
                    />
                  </label>

                  <div
                    onClick={() => handleDelete(index)}
                    className="flex items-center gap-2 px-4 py-2.5 text-sm text-red-500 hover:bg-red-50 cursor-pointer transition-colors"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                    Delete
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Edit Preview */}
          {editingIndex === index && selectedFiles[index] && (
            <div className="mt-5 p-5 bg-gray-50 rounded-xl border-2 border-dashed border-[#0f6abf]">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                <h4 className="text-sm font-semibold text-gray-900">New Video Preview</h4>
              </div>
              <video
                src={URL.createObjectURL(selectedFiles[index])}
                controls
                className="w-full max-h-[300px] rounded-xl shadow-sm"
              />
              <p className="mt-3 text-sm text-gray-600">
                Selected: <span className="font-medium">{selectedFiles[index].name}</span>
              </p>
            </div>
          )}
        </div>
      ))}
    </div>
  ) : !selectedFiles.length && (
    <div
      onClick={() =>
        document.querySelector('.edit-icon input')?.click()
      }
      className="border-2 border-dashed border-gray-300 rounded-2xl p-12 text-center cursor-pointer hover:border-[#0f6abf] hover:bg-[#e8f0f7]/10 transition-colors mt-6"
    >
      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
        </svg>
      </div>
      <h3 className="text-lg font-medium text-gray-700 mb-2">No videos yet</h3>
      <p className="text-sm text-gray-500 mb-4">Click the + icon to upload your first video</p>
      <p className="text-xs text-gray-400">Supported formats: MP4, AVI, MOV, WMV</p>
    </div>
  )}
</div>

  )
}

export default VideoIntro